import '../../../vendor/jquery.autocomplete';

$('input[data-autocomplete]').each(function () {
  const searchField = $(this);


  const form = searchField.parent('form');


  const autoCompleteUrl = searchField.data('autocomplete');

  searchField.autocomplete({
    serviceUrl: autoCompleteUrl,
    minChars: 2,
    zIndex: 1,
    triggerSelectOnValidInput: false,
    appendTo: form,
    onSelect() {
      if (searchField.is('[data-autocomplete-auto-submit]')) {
        form.submit();
      }
    },
  });
});
